<header class="ds-dialog-header" [ngStyle]="headerStyles">
  <h5 class="ds-dialog-title ds-title">{{ data.title }}</h5>
  @if(data.componentInputs?.['showCompactView']) {
    <div style="margin-left: auto;">
        <ds-switch  [formControl]="treeCompactControl" text="Compact View" size="s" [value]="treeCompactControl.value"  (valueChange)="changeCompactView()"/>
    </div>
    <div class="ds-separator"></div>
  }
  <button
    ds-button
    size="xs"
    variantName="tertiary-subtle"
    layout="icon-button"
    class="ds-dialog-close-button"
    (click)="onClose()"
  >
    <ds-icon name="x" size="m" />
  </button>
</header>

<main class="ds-dialog-main" [ngStyle]="bodyStyles">
  <ng-container
    *ngComponentOutlet="dynamicComponent; inputs: componentInputs">
  </ng-container>
</main>

<footer class="ds-dialog-footer" [ngStyle]="footerStyles">
@if (actions.length > 0) {
  @for (action of actions; track (action.label ?? (action.$label ? action.$label() : ''))) {
    <button
      ds-button
      size="s"
      [variantName]="action.variant"
      [disabled]="action.$disabled ? action.$disabled() : false"
      (click)="onActionClick(action)"
    >
      {{ action.label ?? (action.$label ? action.$label() : '') }}
    </button>
  }
}
</footer>

